// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"96":"vendors","470":"settings-vendors"}[chunkId] + "-" + {"96":"802b756aa5d2de53ab93","470":"100164245c8429b08802"}[chunkId] + ".js";
};